const subsidiaryLinkMap = new Map<string, string>([
  ['defiassetsllc', 'https://defiassetsllc.com/'],
  ['vivasvatrevolutions', 'https://vivasvatrevolutions.com/'],
  ['vivasvatrevolutionslimited', 'https://vivasvatrevolutions.com/'],
  ['vivasvatrevoltionslimited', 'https://vivasvatrevolutions.com/'],
  ['aiadyallc', 'https://aiadya.com/'],
  ['cryptoassetratingllc', 'https://cryptoassetratings.com/'],
  ['cryptoassetratingsllc', 'https://cryptoassetratings.com/'],
]);

const subsidiaryNameMap = new Map<string, string>([
  ['vivasvatrevoltionslimited', 'Vivasvat Revolutions Limited'],
]);

function normalizeName(value: string) {
  return value.toLowerCase().replace(/[^a-z0-9]/g, '');
}

export function getSubsidiaryUrl(name: string) {
  return subsidiaryLinkMap.get(normalizeName(name));
}

export function formatSubsidiaryName(name: string) {
  return subsidiaryNameMap.get(normalizeName(name)) || name;
}
